import $ from 'jquery';
import ScrollMagic from 'ScrollMagic';
import 'debug.addIndicators';


export default () => {

    // init controller
    let controller = new ScrollMagic.Controller();

    let offset = 0;
    let duration = 250;
    if ($(window).width() <= 768) {
        offset = 0;
        duration = 100;
    }

    // White Layer
    new ScrollMagic.Scene({
        offset: offset,
        duration: duration,
    })
        .addTo(controller)
        .on("progress", function (e) {

            let S = $("header .logo #S");
            let text = $("header .logo #text");

            text.css({opacity: 1 - e.progress});
            // console.log(e.progress);
            let progess = e.progress * 100 * 0.6;
            S.css({transform: 'translateX(-' + (progess) + 'px)'});

            if($(window).width() <= 768 ) {
                if (e.progress > 0.6) {
                    $('header').css({'background-color': 'rgba(255, 248, 246,' + (0.6 + e.progress) + ')'});
                } else {
                    $('header').css({'background-color': 'rgba(255, 248, 246, 0)'});
                }
            }
        });
};



// WEBPACK FOOTER //
// ./scripts/libs/logo.js